import RichText, { RichTextProps } from './RichText'

export default RichText

export { RichText }
export type { RichTextProps }
